import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
  paymentMethod: string,
  property_id: string,
  transaction_id: string,
  amount: number,
  adPlans: any,
  currentAdPlan: number
}


@Component({
  selector: 'app-bank-transfer',
  templateUrl: './bank-transfer.component.html',
  styleUrls: ['./bank-transfer.component.css']
})
export class BankTransferComponent {

  adPlans = []

  basicInfoForm: FormGroup = new FormGroup({
    paymentMethod: new FormControl('', [Validators.required]),
    property_id: new FormControl('', [Validators.required]),
    transaction_id: new FormControl('', [Validators.required]),
    amount: new FormControl('', [Validators.required]),
    currentAdPlan: new FormControl('', [Validators.required]),
  })

  constructor(
    public dialogRef: MatDialogRef<BankTransferComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.adPlans = data.adPlans
      delete data['adPlans']
      this.basicInfoForm.setValue(data)
    }

  onNoClick(): void {
    this.dialogRef.close()
  }

  saveBankDepositInfo(){
    if(this.basicInfoForm.valid){
      let basicInfo = this.basicInfoForm.value
      this.dialogRef.close(basicInfo)
    }
  }
}

